export function TimerEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="136"
        viewBox="0 0 200 136"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M113.5 6H86.5C82.9101 6 80 8.91015 80 12.5C80 16.0899 82.9101 19 86.5 19H113.5C117.09 19 120 16.0899 120 12.5C120 8.91015 117.09 6 113.5 6Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M106 24C106 20.6863 103.314 18 100 18C96.6863 18 94 20.6863 94 24V28C94 31.3137 96.6863 34 100 34C103.314 34 106 31.3137 106 28V24Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M100 130C127.614 130 150 107.614 150 80C150 52.3858 127.614 30 100 30C72.3858 30 50 52.3858 50 80C50 107.614 72.3858 130 100 130Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M84 76C88 80.6667 92 80.6667 96 76"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 76C108 80.6667 112 80.6667 116 76"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 90C97.3333 94 102.667 94 108 90"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 88.5C80.1569 88.5 81.5 87.1569 81.5 85.5C81.5 83.8431 80.1569 82.5 78.5 82.5C76.8431 82.5 75.5 83.8431 75.5 85.5C75.5 87.1569 76.8431 88.5 78.5 88.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 88.5C120.157 88.5 121.5 87.1569 121.5 85.5C121.5 83.8431 120.157 82.5 118.5 82.5C116.843 82.5 115.5 83.8431 115.5 85.5C115.5 87.1569 116.843 88.5 118.5 88.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M163 38C154.333 40 147.667 44.6667 143 52"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M168 34.9999C174.701 32.3348 180.154 35.5386 179.884 41.6154C173.6 42.3242 169.125 39.3283 168 34.9999Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M168 35.0001C167.291 28.7154 172.243 24.6563 178.112 25.9038C176.865 31.7727 173.099 35.0615 168 35.0001Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M34 30L36 35L41 37L36 39L34 44L32 39L27 37L32 35L34 30Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M170 67.5999C171.436 67.5999 172.6 66.4358 172.6 64.9999C172.6 63.564 171.436 62.3999 170 62.3999C168.564 62.3999 167.4 63.564 167.4 64.9999C167.4 66.4358 168.564 67.5999 170 67.5999Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
